import { bd, } from './index.js';
export function formatMoney(value, locale) {
    const valueSafe = typeof value === 'string' ? bd(value) : value;
    let rounded;
    if (typeof valueSafe === 'number') {
        rounded = valueSafe.toFixed(2);
    }
    else if (typeof valueSafe === 'bigint') {
        rounded = valueSafe;
    }
    else {
        rounded = valueSafe.toFixed();
    }
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'EUR',
    })
        .format(rounded);
}
//# sourceMappingURL=MoneyUtils.js.map